import React, { useState } from "react";
import { useFormik } from "formik";
import { SignupSchema } from "../../components/validationSchema";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import SelectBox from "../../components/CustomWidgets/SelectBox";
import Button from "../../components/CustomWidgets/Button";
import OTPModal from "../../modals/verifyOTP";
import { useDispatch } from "react-redux";
import { signupActions } from "../../components/Redux Slices/signupSlice";
import { signupUser } from "../../components/Actions/signupActions";
import { Input } from "antd";
import FlagIcon from "../../assets/egypt.svg";
import Notification from "../../modals/Notification";
import LoaderComponent from "../../Loader";
import { Image } from "antd";
import "../../styles.css";
import { InputBox } from "../../components/CustomWidgets/InputBox";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import i18n from "../../i18n";

const SignupForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showNotification, setShowNotification] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [responseData, setresponseData] = useState("");
  const [Loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const formik = useFormik({
    initialValues: {
      businessProfile: "Retailer",
      phoneNumber: "",
      country_code: "",
    },
    validationSchema: SignupSchema,
    onSubmit: async (values) => {
      let payload = {
        new_mobile:
          values.phoneNumber?.length == 11
            ? values.phoneNumber?.substring(1)
            : values?.phoneNumber,
        country_code: "+20",
      };
      try {
        // Dispatch the signup request action
        setLoading(true);
        dispatch(signupActions.signupRequest());

        // Dispatch the signupUser action
        const response = await dispatch(signupUser(payload));
        console.log("response?.result?.otp", response?.payload?.result?.otp);
        setOtp(response?.payload?.result?.otp);
        setresponseData(payload);
        if (
          response.payload.message ===
            "Retailer Already exist with this mobile" ||
          response?.payload?.result?.status === "Number already exist"
        ) {
          setShowNotification(true);
          setLoading(false);
          // console.log("called")
        } else if (
          response?.payload?.result?.status === 400 ||
          response?.payload?.result?.status ===
            "Mobile is not valid with country code"
        ) {
          toast.error(t(response?.payload?.result?.response));
        }
        // Check if the signupUser action was fulfilled successfully
        else if (signupUser.fulfilled.match(response)) {
          // Dispatch the signup success action
          dispatch(signupActions.signupSuccess(response.payload));

          // Handle additional logic here

          // Show OTP Modal on successful API call
          setLoading(false);
          setShowOTPModal(true);
        } else {
          // Dispatch the signup failure action with the error message
          dispatch(signupActions.signupFailure(response.payload));
        }
      } catch (error) {
        console.error("API request error:", error);
      } finally {
        setLoading(false);
      }
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Modify the value if needed, e.g., format phone number
    e.target.value < 9999999999 && formik.setFieldValue(name, value);
    setShowNotification(false);
  };
  const handleNumberChange = (e) => {
    setShowOTPModal(false);
  };

  return (
    <div className="mx-auto mt-4 w-full sm:mt-5">
      <form onSubmit={formik.handleSubmit}>
        {/* <SelectBox
          // style={{ marginTop: "0vh" }}
          label={t("Business Profile")}
          // Use defaultValue to set the initial value
          name="businessProfile"
          onChange={formik.handleChange}
          options={[
            { value: "Retailer", label: t("retailer") },
            // { value: "Wholesaler", label: "Wholesaler" },
          ]}
          onBlur={formik.handleBlur}
          value={formik.values.businessProfile} // Use value to keep the selected value updated
          error={formik.errors.businessProfile}
          touched={formik.touched.businessProfile}
          className={`${
            formik.touched.businessProfile && formik.errors.businessProfile
              ? "border-red !important" // Apply red border when touched or notification shown
              : ""
          }`}
        /> */}
        <div style={{ direction: "ltr" }} className="flex flex-col">
          <label
            className={`py-2 text-sm text-gray-600 font-medium ${
              i18n.language == "ar"
                ? "self-end" // Apply red border when touched or notification shown
                : ""
            }`}
          >
            {t("Mobile Number")}
          </label>
          <div className="mt-0 flex w-full flex-row items-center">
            <div className="flex h-10 w-14 shrink-0 items-center justify-center rounded-md border p-2 text-md text-body outline-none focus:outline-none sm:w-16 sm:p-3">
              <img src={FlagIcon} height={50} width={50} alt="img" />
            </div>
            <Input
              type="number"
              placeholder="01-xxxxxxxx"
              value={formik.values.phoneNumber}
              onChange={handleChange}
              onBlur={formik.handleBlur}
              name="phoneNumber"
              maxLength={11}
              className={`ms-2 h-10 w-full text-sm text-body outline-none focus:outline-none ltr:pl-5 rtl:pr-5 rounded-md border p-3 sm:text-base ${
                (formik.touched.phoneNumber && formik.errors.phoneNumber) ||
                showNotification
                  ? "border-red" // Apply red border when touched or notification shown
                  : ""
              }`}
            />
          </div>
          {showNotification ? (
            <div className="ml-1 mt-1 flex justify-start text-sm text-red sm:ml-16">
              {t("user_exist")}
            </div>
          ) : null}
        </div>
        <div className="my-8">
          <button
            type="submit"
            className="relative mt-4 my-4 flex w-full items-center justify-center rounded-lg bg-primaryBlue p-3 text-sm font-semibold text-white sm:text-base"
            disabled={Loading}
          >
            {" "}
            {t("Send OTP")}{" "}
            {Loading && (
              <>
                <div className="ms-4 mb-2">
                  <LoaderComponent />
                </div>
              </>
            )}
          </button>
        </div>
      </form>

      {showOTPModal && (
        <>
          <OTPModal
            responseData={responseData}
            mobile={responseData?.new_mobile}
            isOpen={showOTPModal}
            numberChange={handleNumberChange}
            onClose={() => setShowOTPModal(false)}
            otp={otp}
            // handlecancel={() => setShowOTPModal(false)}
            payload={() => {
              setShowOTPModal(false);
            }}
          />
        </>
      )}
    </div>
  );
};

export default SignupForm;
